exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.btnWidthSentPhoto[data-v-2b505c26]{\n      width:200px;        \n      display:inline-block;\n}\n.PrincipalImageStyle[data-v-2b505c26] {\n      background: cadetblue;\n}\n.NonPrincipalImageStyle[data-v-2b505c26]{\n      background: red;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-2b505c26","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ImageUpload.vue
// module id = 77
// module chunks = 0